import { useEffect, useState } from "react";
import { cfgPartial, cfgUpdate } from "../api/api";
import BottomSheet from "../components/BottomSheet";
import {useApp} from "../Contex";

export default function Config() {
    const {refresh, permissions:{write}} = useApp()
    const [config, setConfig] = useState({});
    const [expandedMap, setExpandedMap] = useState({});

    const [edit, setEdit] = useState(null);

    const fetchData = () => {
        cfgPartial([]).then((ret) => {
            if (ret.ok) {
                setConfig(ret.data);
            }
        });
    };

    const editFields = {
        sid: { name: "Plats ID", static: true},
        text: { name: "Visningsnamn"},
        city: { name: "Stad"},
        tele: { name: "Telefonnummer"},
        "hours.ftid": { name: "Öppet från"},
        "hours.ttid": { name: "Öppet till"},
        "chan.eatin.channel": {name: "Idk testar bara"},
    };

    const getValueByPath = (obj, path) => path.split(".").reduce((acc, part) => acc?.[part], obj);

    const EditModal = ({ prop }) => {
        const [value, setValue] = useState(getValueByPath(config, prop.prop));

        const handleChange = (e) => setValue(e.target.value);

        const handleSave = () => {
            cfgUpdate({ [prop.prop]: value }).then((ret) => {
                if (ret.ok) {
                    fetchData();
                    setEdit(null);
                }
            });
        };

        return (
            <>
                <div className="d-flex gap-2 align-items-center mb-3 p-1">
                    <h4 className="fw-bold mb-0">{prop.name}</h4>
                    <button
                        className="btn btn-success d-flex align-items-center gap-2"
                        onClick={handleSave}
                        style={{
                            visibility: value !== getValueByPath(config, prop.prop) ? "visible" : "hidden"
                        }}
                    >
                        <i className="bi bi-check-circle-fill" />
                        Spara
                    </button>
                </div>
                <input
                    type={prop.type === "phone" ? "tel" : "text"}
                    className="form-control form-control-lg"
                    value={value}
                    onChange={handleChange}
                    placeholder={`Ange ${prop?.name?.toLowerCase()}`}
                />
            </>
        );
    };

    const FieldItem = ({ path, value, uneditable, expandedMap, setExpandedMap }) => {
        const indentClass ="ms-3 border-start ps-3";
        const currentKey = path.split(".").pop();
        const fieldMeta = editFields[path] || { name: currentKey };
        const isEditable = !editFields[path]?.static;

        const isExpandable = typeof value === "object" && value !== null;
        const isExpanded = expandedMap[path] ?? true;

        const toggleExpanded = () => {
            setExpandedMap(prev => ({ ...prev, [path]: !isExpanded }));
        };

        if (isExpandable) {
            return (
                <div className={`card mb-2 p-2 bg-light ${indentClass}`}>
                    <div
                        className="d-flex justify-content-between align-items-center"
                        style={{ cursor: "pointer" }}
                        onClick={toggleExpanded}
                    >
                        <h6 className="text-muted fw-bold mb-0">
                            {fieldMeta.name}
                            <i className={`bi mx-2 ${isExpanded ? "bi-chevron-down" : "bi-chevron-right"}`}/>
                        </h6>
                    </div>

                    {isExpanded &&
                        Object.entries(value).map(([subKey, subVal]) => (
                            <FieldItem
                                key={`${path}.${subKey}`}
                                path={`${path}.${subKey}`}
                                value={subVal}
                                expandedMap={expandedMap}
                                setExpandedMap={setExpandedMap}
                            />
                        ))}
                </div>
            );
        }

        return (
            <div className={`card mb-2 p-2 bg-light ${indentClass}`}>
                <div className="d-flex justify-content-between align-items-center">
                    <div>
                        <p className="text-muted mb-1">{fieldMeta.name}</p>
                        <h6 className="mb-0">{value ?? "—"}</h6>
                    </div>
                    {isEditable && write && (
                        <button
                            className="btn btn-outline-secondary"
                            onClick={() => setEdit({ prop: path, ...fieldMeta })}
                        >
                            <i className="bi bi-pencil-square"></i>
                        </button>
                    )}
                </div>
            </div>
        );
    };



    useEffect(() => {
        fetchData();
    }, [refresh]);

    return (
        <>
            <h1 className="fw-bold">Konfiguration</h1>
            {Object.entries(config).map(([key, value]) => (
                <FieldItem
                    key={key}
                    path={key}
                    value={value}
                    level={0}
                    expandedMap={expandedMap}
                    setExpandedMap={setExpandedMap}
                />
            ))}

            <BottomSheet show={edit} setShow={setEdit}>
                {edit && <EditModal prop={edit} />}
            </BottomSheet>
        </>
    );
}
